import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import "../../components/css/emptySlider.css";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import kontriman_statement_illustration_image from "../../assets/static/global/kontriman_iilustrattion_statement.webp";

// Hardcoded list of valid statement details
const validStatements = [
  {
    referenceNumber: "KNMPUI2829",
    idNumber: "SW03065I5JAIQOFHYRM0",
    accountNumber: "50017436784",
    prefix: "Verified Statement",
  },
];

function VerifyStatement() {
  const [form, setForm] = useState({
    referenceNumber: "",
    idNumber: "",
    accountNumber: "",
    prefix: "Verified Statement",
  });

  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState("");
  const formRef = useRef(null); // For manual form submit

  useEffect(() => {
    const savedAccount = Cookies.get("verified_account");
    if (savedAccount) {
      setError(""); // Optional: Block direct link access here if needed
    }
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
    Cookies.remove("verified_account");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const match = validStatements.find(
      (entry) =>
        entry.referenceNumber === form.referenceNumber &&
        entry.idNumber === form.idNumber &&
        entry.accountNumber === form.accountNumber
    );

    if (match) {
      Cookies.set("verified_account", match.accountNumber, { expires: 0.01 });
      setIsVerified(true);
      setError("");
    } else {
      setIsVerified(false);
      setError("❌ Statement verification failed. Please check your details.");
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault(); // Prevent immediate form submission

    const btn = e.target;
    const formElement = formRef.current;

    btn.disabled = true;
    const originalText = btn.innerHTML;
    btn.innerHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Please wait...`;

    setTimeout(() => {
      btn.disabled = false;
      btn.innerHTML = originalText;
      formElement.requestSubmit(); // Manually trigger form submit
    }, 3000);
  };

  return (
    <div>
      <NavMenu />
      <br />
      <br />
      <br />
      <br />
      <div className="container-fluid py-5 customEmptySlider">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <h1 className="headingText">Verify Statement</h1>
              <p className="customText">
                Statement Verification is a service that allows you to confirm
                whether the account details on a statement issued by a third
                party are valid and authentic.
              </p>
            </div>

            {!isVerified && (
              <>
                <div className="col-12 col-md-4 mb-4">
                  <form onSubmit={handleSubmit} ref={formRef}>
                    <div className="mb-3">
                      <label className="form-label">Reference Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter reference number"
                        name="referenceNumber"
                        value={form.referenceNumber}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Client's National ID Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Client's National ID Number"
                        name="idNumber"
                        value={form.idNumber}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Account Number</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter account number"
                        name="accountNumber"
                        value={form.accountNumber}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={handleButtonClick}
                    >
                      Verify
                    </button>
                  </form>
                  {error && (
                    <div className="alert alert-danger mt-3">{error}</div>
                  )}
                </div>

                <div className="col-12 col-md-6 d-none d-md-flex justify-content-center align-items-center">
                  <img
                    src={kontriman_statement_illustration_image}
                    alt="Verify Illustration"
                    className="img-fluid"
                    style={{ maxWidth: "60%", height: "auto" }}
                  />
                </div>
              </>
            )}
          </div>

          {isVerified && (
            <div className="row mt-5">
              <div className="col-12">
                <center>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100"
                      height="100"
                      viewBox="0 0 64 64"
                    >
                      {/* Big green circle */}
                      <circle cx="32" cy="32" r="30" fill="#2e3457" />

                      {/* White checkmark path */}
                      <path
                        fill="none"
                        stroke="#fff"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M16 33l12 12 20-24"
                      />
                    </svg>
                    
                  </div>
                </center>
                <center>
                <strong>Verified</strong>
                </center>
                <table className="table mt-4">
                  <thead className="table-light">
                    <tr>
                      <th>Status</th>
                      <th>Account Number</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Valid</td>
                      <td>{form.accountNumber}</td>
                      <td>
                        <a
                          href={`/statements/${form.prefix} - ${form.referenceNumber} - ${form.accountNumber}.pdf`}
                          download
                          className="btn btn-primary btn-sm"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Info */}
          <div className="row mt-5">
            <div className="col-12">
              <strong>Please Note:</strong>
              <ul className="mb-0 mt-2">
                <li>
                  Enter all fields exactly as they appear on the statement, as{" "}
                  <strong>all fields are case sensitive</strong>.
                </li>
                <li>
                  For individuals, enter the{" "}
                  <strong>reference number, account number</strong>, and the{" "}
                  <strong>National ID Number</strong>.
                </li>
                <li>
                  For businesses, enter the{" "}
                  <strong>reference number, business account number</strong>,
                  and the individual's <strong>National ID Number</strong>.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default VerifyStatement;
